export interface CustomLayer {
  id: number;
  name: string;
  project: number;
  geom_type: string | null;
  feature_count: number;
  color: string;
  opacity: number;
}

export const DEFAULT_CUSTOM_LAYER_COLOR = "#1abc9c";
export const DEFAULT_CUSTOM_LAYER_OPACITY = 0.4;
